import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BLACK, BLACK_700, BLACK_900, LILAC_400, TRANSPARENT, Typography, getTestId, isValidObject, useBreakpoint } from '@airtel/air-design-system';
import { useState } from 'react';
import { Image, Pressable, View } from 'react-native';
import { getTextType } from '../../OrderSummaryCardWidgetStyles';
import { getPackInfoStyles } from './PackInfoStyles';
var PackInfo = props => {
  var _props$subtitleHeadin = props.subtitleHeading,
    subtitleHeading = _props$subtitleHeadin === void 0 ? '' : _props$subtitleHeadin,
    _props$title = props.title,
    title = _props$title === void 0 ? '' : _props$title,
    _props$subTitle = props.subTitle,
    subTitle = _props$subTitle === void 0 ? '' : _props$subTitle,
    _props$titleProps = props.titleProps,
    titleProps = _props$titleProps === void 0 ? {} : _props$titleProps,
    _props$subtitleProps = props.subtitleProps,
    subtitleProps = _props$subtitleProps === void 0 ? {} : _props$subtitleProps,
    _props$packInfoTitleS = props.packInfoTitleStyle,
    packInfoTitleStyle = _props$packInfoTitleS === void 0 ? {} : _props$packInfoTitleS,
    _props$additionalBene = props.additionalBenefits,
    additionalBenefits = _props$additionalBene === void 0 ? [] : _props$additionalBene,
    onUserAction = props.onUserAction,
    id = props.id,
    onAdditionalBenefitsPressMetaData = props.onAdditionalBenefitsPressMetaData,
    _props$extraBenefitsA = props.extraBenefitsAccessibilityProps,
    extraBenefitsAccessibilityProps = _props$extraBenefitsA === void 0 ? {} : _props$extraBenefitsA,
    _props$titleAccessibi = props.titleAccessibilityProps,
    titleAccessibilityProps = _props$titleAccessibi === void 0 ? {} : _props$titleAccessibi,
    _props$subtitleAccess = props.subtitleAccessibilityProps,
    subtitleAccessibilityProps = _props$subtitleAccess === void 0 ? {} : _props$subtitleAccess,
    _props$subtitleHeadin2 = props.subtitleHeadingAccessibilityProps,
    subtitleHeadingAccessibilityProps = _props$subtitleHeadin2 === void 0 ? {} : _props$subtitleHeadin2,
    _props$titleSubtitleA = props.titleSubtitleAccessibilityProps,
    titleSubtitleAccessibilityProps = _props$titleSubtitleA === void 0 ? {} : _props$titleSubtitleA,
    testID = props.testID;
  var _useState = useState(TRANSPARENT),
    placeholderBgColor = _useState[0],
    setPlaceholderBgColor = _useState[1];
  var updatedBenefits = !!additionalBenefits && [...additionalBenefits];
  var hiddenBenefitsCount = 0;
  if ((additionalBenefits === null || additionalBenefits === void 0 ? void 0 : additionalBenefits.length) > 5) {
    updatedBenefits.length = 4;
    hiddenBenefitsCount = (additionalBenefits === null || additionalBenefits === void 0 ? void 0 : additionalBenefits.length) - (updatedBenefits === null || updatedBenefits === void 0 ? void 0 : updatedBenefits.length);
  }
  var _useBreakpoint = useBreakpoint({
      allowMdAsLargeScreen: true,
      returnAsObject: true
    }),
    isSmallScreen = _useBreakpoint.isSmallScreen;
  var packInfoStyles = getPackInfoStyles(isSmallScreen);
  var getHiddenCountAccessibilityLabel = () => {
    return "+" + hiddenBenefitsCount + " benefit" + (hiddenBenefitsCount > 1 ? 's' : '');
  };
  var Wrapper = isValidObject(onAdditionalBenefitsPressMetaData) ? Pressable : View;
  return _jsxs(View, Object.assign({
    style: packInfoStyles.packDetailContainer
  }, getTestId(testID, 'packInfo'), titleSubtitleAccessibilityProps, {
    children: [(subtitleHeading === null || subtitleHeading === void 0 ? void 0 : subtitleHeading.length) > 0 && _jsx(Typography, Object.assign({
      type: getTextType('subheading', isSmallScreen),
      text: subtitleHeading,
      color: BLACK_700,
      style: packInfoStyles.subtitleHeading
    }, getTestId(testID, 'subtitleHeading'), subtitleHeadingAccessibilityProps)), (title === null || title === void 0 ? void 0 : title.length) > 0 && _jsx(Typography, Object.assign({
      type: titleProps.type || getTextType('heading', isSmallScreen),
      text: title,
      color: BLACK_900,
      style: isValidObject(packInfoTitleStyle) ? packInfoTitleStyle : packInfoStyles.packDetailsTitle
    }, titleProps, getTestId(testID, 'packInfoTitle'), titleAccessibilityProps)), (subTitle === null || subTitle === void 0 ? void 0 : subTitle.length) > 0 && _jsx(Typography, Object.assign({
      type: subtitleProps.type || getTextType('subheading', isSmallScreen),
      text: subTitle,
      color: BLACK_700
    }, subtitleProps, getTestId(testID, 'packInfoSubTitle'), subtitleAccessibilityProps)), (updatedBenefits === null || updatedBenefits === void 0 ? void 0 : updatedBenefits.length) > 0 && _jsxs(View, Object.assign({
      style: packInfoStyles.benefitsContainer
    }, getTestId(testID, 'packInfoBenefits'), {
      children: [(updatedBenefits === null || updatedBenefits === void 0 ? void 0 : updatedBenefits.length) > 0 && (updatedBenefits === null || updatedBenefits === void 0 ? void 0 : updatedBenefits.map((benefit, index) => {
        var benefitUrl = benefit.benefitUrl;
        return _jsx(Wrapper, Object.assign({
          onPress: () => {
            isValidObject(onAdditionalBenefitsPressMetaData) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
              id
            }, onAdditionalBenefitsPressMetaData), props));
          }
        }, benefit === null || benefit === void 0 ? void 0 : benefit.accessibilityProps, {
          children: !!benefitUrl && _jsx(Image, {
            source: {
              uri: benefitUrl,
              width: 28,
              height: 28
            },
            style: [{
              backgroundColor: placeholderBgColor
            }, packInfoStyles.benefitsImages],
            onError: () => setPlaceholderBgColor(LILAC_400)
          })
        }), benefitUrl + "_" + index);
      })), hiddenBenefitsCount > 0 && _jsx(Pressable, Object.assign({
        onPress: () => {
          onAdditionalBenefitsPressMetaData && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
            id
          }, onAdditionalBenefitsPressMetaData), props));
        }
      }, extraBenefitsAccessibilityProps, {
        children: _jsx(Typography, {
          text: "+" + hiddenBenefitsCount,
          type: "body-single-line-xs",
          color: BLACK,
          style: packInfoStyles.hiddenBenefitsCountContainer,
          accessibilityLabel: getHiddenCountAccessibilityLabel()
        })
      }))]
    }))]
  }));
};
export default PackInfo;